import { useState } from "react";
import { faqs } from "@/mocks/movies";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[900px] px-4 md:px-8">
        <SectionHeading
          eyebrow="常见问题"
          title="关于排行榜与找片，你可能会问"
          desc="下面汇总了浏览本页时最常见的问题，点击标题即可展开查看详细说明。"
          accent="secondary"
        />

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200"
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={`text-base ${open ? "ri-subtract-line" : "ri-add-line"}`} />
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    open ? "max-h-96 border-t border-background-200" : "max-h-0"
                  }`}
                >
                  <p className="px-5 py-4 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}